/**
 * OrbDocGettingStartedIntroductionENOrbDocGettingStartedIntroductionENPage
 *
 * Page component for OrbDocGettingStartedIntroductionENOrbDocGettingStartedIntroductionENPage
 * Path: /docs/getting-started/introduction
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocGettingStartedIntroductionENDocScreenView as __OrbDocGettingStartedIntroductionENDocScreenView } from '@/components/traits/OrbDocGettingStartedIntroductionENDocScreenView';
import { OrbDocGettingStartedIntroductionENDocAnalyticsView as __OrbDocGettingStartedIntroductionENDocAnalyticsView } from '@/components/traits/OrbDocGettingStartedIntroductionENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocGettingStartedIntroductionENOrbDocGettingStartedIntroductionENPageProps {
  // Add any page-level props here
}

export function OrbDocGettingStartedIntroductionENOrbDocGettingStartedIntroductionENPage(_props: OrbDocGettingStartedIntroductionENOrbDocGettingStartedIntroductionENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Introduction to Orb","description":"Orb is a language for software that has to follow rules. You declare the states and the events; the compiler builds the app or tells you why it can't.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/getting-started/introduction"},{"locale":"ar","path":"/ar/docs/getting-started/introduction"},{"locale":"sl","path":"/sl/docs/getting-started/introduction"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocGettingStartedIntroductionENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocGettingStartedIntroductionENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocGettingStartedIntroductionENOrbDocGettingStartedIntroductionENPage;
